import { MarginOptions } from '@lendi-ui/spacing';
import { Body, Heading, HeadingProps } from '@lendi-ui/typography';

import { NextArrowAction } from '@funnels/ui-components';

import { ActionButtonsWrapper, Container, ContentWrapper, HeadingWrapper } from '../style';

interface CardProps {
  heading: string | JSX.Element;
  additionalHeadingProps?: Partial<HeadingProps & MarginOptions>;
  preHeading?: JSX.Element;
  subHeading?: JSX.Element | string;
  hasActions?: boolean;
  isActionDisabled?: boolean;
  onActionClick?: () => void;
  actionCustomText?: string;
  additionalActions?: JSX.Element | null;
}

export const Card: React.FunctionComponent<CardProps> = ({
  heading,
  preHeading,
  subHeading,
  hasActions = true,
  isActionDisabled = false,
  onActionClick,
  children,
  actionCustomText,
  additionalActions,
  additionalHeadingProps,
}) => {
  return (
    <Container>
      <HeadingWrapper>
        {preHeading}
        <Heading size="md" {...additionalHeadingProps} data-testid="header-page-heading">
          {heading}
        </Heading>
        {typeof subHeading === 'string' ? <Body>{subHeading}</Body> : subHeading}
      </HeadingWrapper>
      <ContentWrapper>{children}</ContentWrapper>
      {hasActions && (
        <ActionButtonsWrapper>
          <NextArrowAction
            variant="primary"
            isFullWidth
            isDisabled={isActionDisabled}
            onClick={onActionClick}
            customText={actionCustomText}
          />
          {additionalActions}
        </ActionButtonsWrapper>
      )}
    </Container>
  );
};
